module.exports = __webpack_public_path__ + "static/media/img1.01f01bbf.jpeg";